<template>
    <div class="content-wrapper" :class="{'force-table-create-operator-styles': createOperatorStyles}">
        <div class="description">
            {{ `${description ? description : account.account.description} - ` }}
            <span v-mask="ACCOUNT_NUMBER">{{ account.account.accountNumber }}</span>
            <span v-if="account.account.id === defaultAccount">{{ ` (${t('approvals.operators.operatorDetails.accountAccessedBlock.default')})` }}</span>
        </div>

        <table-with-horizontal-scroll
        v-if="Object.keys(account.operationLimits).length"
        noBoxStyles
        :hasDetail="false"
        :headerData="operationTableHeaderData"
        :tableStyles="operationTableStyles"
        :tableData="operationTableData"/>
    </div>
</template>

<script setup>
import TableWithHorizontalScroll from '@/components/generic/table/WithHorizontalScroll'
/* Aux */
import { computed } from 'vue'
import { ACCOUNT_NUMBER } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
    createOperatorStyles: Boolean,
    description: String,
    account: Object,
    defaultAccount: Number
})

const operationTableHeaderData = [
	{
        label: t('approvals.operators.operatorDetails.accountAccessedBlock.tableHeader.name'),
        dataAttr: 'name',
        rowCellType: 'description',
        showInMobile: true
    }, {
        label: t('approvals.operators.operatorDetails.accountAccessedBlock.tableHeader.dailyPlafond'),
        dataAttr: 'dailyPlafond',
        rowCellType: 'amount',
        showInMobile: true
    }, {
        label: t('approvals.operators.operatorDetails.accountAccessedBlock.tableHeader.transactionLimit'),
        dataAttr: 'transactionLimit',
        rowCellType: 'amount',
        showInMobile: true
    }
]

const operationTableStyles = [
    { width: '220px', 'min-width': '220px' },
    { width: '200px', 'min-width': '200px', 'text-align': 'end' },
    { width: '200px', 'min-width': '200px', 'text-align': 'end' }
]

const operationTableData = computed(() => {
    const tableData = []

    for (const operation in props.account.operationLimits) {
        const operationLimits = props.account.operationLimits
        tableData.push([
            { value: operationLimits[operation].operationType.id, dataAttr: 'id' },
            { type: 'description', value: operationLimits[operation].operationType.name, dataAttr: 'name' },
            {
                type: 'amount',
                value: {
                    content: operationLimits[operation].dailyPlafond,
                    currency: props.account.account.currency,
                    noBalanceIcon: true
                },
                dataAttr: 'dailyPlafond'
            },
            {
                type: 'amount',
                value: {
                    content: operationLimits[operation].transactionLimit,
                    currency: props.account.account.currency,
                    noBalanceIcon: true
                },
                dataAttr: 'transactionLimit'
            }
        ])
    }
    return tableData
})
</script>

<style lang="scss" scoped>
.content-wrapper {
    width: 100%;

    border: 1px solid var(--secondary-light-2);
    border-radius: 12px;

    .description {
        margin: 16px 16px 24px 16px;

        @include H6-Medium;
        line-height: 18px;
        color: var(--secondary-dark-2);
    }
}
</style>
